import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import arrowLeft from '../../assets/icons/arrow-left.svg';
import '../../styles/css/Karyawan.css';
import DetailForm from '../../components/karyawan/DetailForm';
import DetailFotoProfile from '../../components/karyawan/DetailFotoProfile';
import { useDispatch, useSelector } from 'react-redux';
import Sidebar from '../../components/sidebar/Sidebar';
import {
    detailSiswa,
    resetListSiswa,
    updateSiswa,
    updateStateSiswa
} from '../../features/siswaSlice';
import { getKategori } from '../../features/ketegoriSlice';
import InfoBox from '../../components/InfoBox';
import LoadingFullscreen from '../../components/LoadingFullscreen';
import DetailFormSiswa from "../../components/student/DetailFormSiswa";
import {getKelas} from "../../features/kelasSlice";

function DetailSiswa() {
    const { id: userId } = useParams();
    const dispatch = useDispatch();
    const {
        nama, password, errors, kelas,
        statusResApi, messageResApi, isDisplayMessage, loadingEdit, isFormEditted
    } = useSelector((state) => state.siswa);
    const navigate = useNavigate();
    const [showAlertBack, setShowAlertBack] = useState(false);
    const [showAlertUpdate, setShowAlertUpdate] = useState(false);


    useEffect(() => {
        // Reset data lama untuk memastikan data fresh
        dispatch(resetListSiswa());
        dispatch(updateStateSiswa({ name: 'isFormEditted', value: false }));

        // Fetch data detail karyawan dan kategori
        dispatch(detailSiswa(userId));
        dispatch(getKelas());
    }, [userId, dispatch]);

    function updateUser(e) {
        e.preventDefault();
        setShowAlertUpdate(true);
    }

    function handleApiUpdate() {

        console.log({
            id: userId,
            nama: nama,
            password: password,
            class_id: kelas.id
        })

        dispatch(
            updateSiswa({
                id: userId,
                nama: nama,
                password: password,
                class_id: kelas.id
            })
        ).then(() => {
            navigate(-1);
        });
    }

    function handleBack() {
        if (isFormEditted) {
            setShowAlertBack(true);
        } else {
            navigate(-1);
        }
    }

    return (
        <div className="wrapper-karyawan">
            <Sidebar />
            <div className="detail-karyawan">
                <div className="navigation">
                    <div>
                        <img src={arrowLeft} alt="" onClick={handleBack} />
                        <h1>Detail Karyawan</h1>
                    </div>

                    <input
                        disabled={
                            errors.nama === '' &&
                            errors.password === ''
                                ? false
                                : true
                        }
                        type="button"
                        value="Konfirmasi"
                        className="btn-submit"
                        onClick={updateUser}
                    />
                </div>
                <div className="detail-form">
                    <DetailFormSiswa />

                </div>
                <LoadingFullscreen loading={loadingEdit} />
            </div>

            {showAlertBack && (
                <div className="bg-modal">
                    <div className="alert-modal">
                        <h1>Edit Karyawan</h1>
                        <p>
                            Ada perubahan yang belum Anda simpan, Anda yakin ingin
                            membatalkan?
                        </p>
                        <div>
                            <button onClick={() => setShowAlertBack(false)}>Tidak</button>
                            <button onClick={() => navigate(-1)}>Iya</button>
                        </div>
                    </div>
                </div>
            )}

            {showAlertUpdate && (
                <div className="bg-modal">
                    <div className="alert-modal">
                        <h1>Edit Siswa</h1>
                        <p>Kamu yakin edit siswa ini?</p>
                        <div>
                            <button onClick={() => setShowAlertUpdate(false)}>Tidak</button>
                            <button onClick={handleApiUpdate}>Iya</button>
                        </div>
                    </div>
                </div>
            )}

            <InfoBox
                message={messageResApi}
                status={statusResApi}
                isDisplay={isDisplayMessage}
                setIsDisplay={updateStateSiswa}
                stateName="isDisplayMessage"
            />
        </div>
    );
}

export default DetailSiswa;
